import { styled } from '@mui/styles'
import { useAppDispatch } from '../../store/hooks'
import { RootState } from '../../store/store'
import { useSelector } from 'react-redux'
import { FieldContainer } from '../ui/FIeldContainer'
import { Label } from '../ui/Label'
import { Button, Input } from 'antd'
import { ChangeEvent } from 'react'
import {
    ActiveModal,
    ProductFilters,
    openModal,
    setProductFilters,
} from '../../store/products-slice'

const Container = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
}))

const InputsContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: '0px 0px 10px 0px',
    gap: '5px',
}))

const ActionsContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: '0px 0px 10px 0px',
    gap: '5px',
}))

export const ProductsTopBar = () => {
    const { productFilters } = useSelector((state: RootState) => state.products)
    const dispatch = useAppDispatch()

    const mutateProductFilters = (
        key: keyof ProductFilters,
        value: string | number | undefined
    ) => {
        dispatch(setProductFilters({ ...productFilters, [key]: value }))
    }

    return (
        <Container>
            <InputsContainer>
                <FieldContainer>
                    <Label>Id</Label>
                    <Input
                        style={{ width: '150px' }}
                        value={productFilters.productId}
                        onChange={(event: ChangeEvent<HTMLInputElement>): void => {
                            if (
                                isNaN(parseInt(event.target.value)) ||
                                parseInt(event.target.value) === 0
                            ) {
                                mutateProductFilters('productId', undefined)
                            } else {
                                mutateProductFilters('productId', Number(event.target.value))
                            }
                        }}
                    />
                </FieldContainer>
                <FieldContainer>
                    <Label>Code</Label>
                    <Input
                        style={{ width: '200px' }}
                        value={productFilters.code}
                        onChange={(event: ChangeEvent<HTMLInputElement>): void => {
                            mutateProductFilters('code', event.target.value)
                        }}
                    />
                </FieldContainer>
                <FieldContainer>
                    <Label>Name</Label>
                    <Input
                        style={{ width: '200px' }}
                        value={productFilters.name}
                        onChange={(event: ChangeEvent<HTMLInputElement>): void => {
                            mutateProductFilters('name', event.target.value)
                        }}
                    />
                </FieldContainer>
                <FieldContainer>
                    <Label>Product Group</Label>
                    <Input
                        style={{ width: '200px' }}
                        value={productFilters.productGroup}
                        onChange={(event: ChangeEvent<HTMLInputElement>): void => {
                            mutateProductFilters('productGroup', event.target.value)
                        }}
                    />
                </FieldContainer>
            </InputsContainer>
            <ActionsContainer>
                <Button
                    type="primary"
                    onClick={() => {
                        dispatch(openModal({ activeModal: ActiveModal.ProductCreate }))
                    }}
                >
                    Create Product
                </Button>
            </ActionsContainer>
        </Container>
    )
}
